export * from './axios';
import { v4 } from 'uuid';
export const removeHash = () => {
    history.pushState('', document.title, window.location.pathname + window.location.search);
};
export const generateUUID = () => v4();
//# sourceMappingURL=index.js.map